import { render, staticRenderFns } from "./ClaimItemsStats.vue?vue&type=template&id=24decbb0&scoped=true&"
import script from "./ClaimItemsStats.vue?vue&type=script&lang=js&"
export * from "./ClaimItemsStats.vue?vue&type=script&lang=js&"
import style0 from "./ClaimItemsStats.vue?vue&type=style&index=0&id=24decbb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24decbb0",
  null
  
)

export default component.exports